import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { style: {"color":"green"} }

import { storeToRefs } from 'pinia';
import { useScannerCouponStore } from '@/store/useScannerCoupon';

export default /*@__PURE__*/_defineComponent({
  __name: 'couponScanner',
  setup(__props) {

const scannerCoupon = useScannerCouponStore();

const { scanners } = storeToRefs(scannerCoupon);

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scanners), (scanner) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          md: "3",
          key: scanner.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "mx-auto my-12",
              "max-width": "374",
              hover: "",
              to: { name: 'Scanner', params: { id: scanner.id } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: _normalizeClass(scanner.cardClass)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      "align-center": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "mx-auto my-12",
                          "max-width": "350",
                          color: "transparent",
                          flat: "",
                          tile: ""
                        }, {
                          default: _withCtx(() => [
                            (scanner.type == 'scanner')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  height: "100",
                                  src: require('@/assets/icons/scanner.png'),
                                  style: {"object-fit":"cover","width":"100%"}
                                }, null, 8, _hoisted_1))
                              : _createCommentVNode("", true),
                            (scanner.type == 'validation')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  height: "100",
                                  src: require('@/assets/icons/validation.png'),
                                  style: {"object-fit":"cover","width":"100%"}
                                }, null, 8, _hoisted_2))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class"]),
                _createVNode(_component_v_card_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scanner.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(scanner.description), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_divider, { class: "mx-4 mb-1" }),
                (scanner.count_new_status && scanner.count_new_status > 0)
                  ? (_openBlock(), _createBlock(_component_v_card_title, {
                      key: 0,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(scanner.count_new_status + (scanner.count_error_status || 0)) + " nouveaux coupons ", 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_v_card_title, {
                      key: 1,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("p", { style: {"color":"red"} }, "Pas de nouveaux coupons", -1)
                      ]))]),
                      _: 1
                    }))
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})